// Get the button
const goToTopButton = document.getElementById('goToTop');

// When the user scrolls down 200px from the top of the document, show the button
window.onscroll = function() {
  if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
    goToTopButton.style.display = 'block';
  } else {
    goToTopButton.style.display = 'none';
  }
};

// When the user clicks on the button, scroll to the top of the document
goToTopButton.addEventListener('click', function() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});
